module.exports = __webpack_public_path__ + "img/step22_a_stand_power_remove_stacker_tray_Julio2023.91d4d4e2.png";